import React, { Component } from 'react'
import classes from './NotFound.scss'

class Lightbox extends Component {
  render () {
    return <div className={classes.notFound}>ไม่พบสินค้าที่ค้นหา</div>
  }
}

export default Lightbox



// WEBPACK FOOTER //
// ./src/components/NotFound.js